import { getImagePath, getLocalImagePath, isEmpty } from '@/common/utils/Util';
import dayjs from 'dayjs';

export const imageBinding = fileName => {
  return `background: url(${getImagePath(fileName)}) no-repeat;`;
  // return `background: url(${getLocalImagePath(fileName)}) no-repeat;`;
};

export const getFamilyInfo = list => {
  if (isEmpty(list)) return;
  return list
    .map(item => `${item.relation}: ${item.name}`) // "relation: name" 형식으로 변환
    .join(', '); // 쉼표와 공백으로 배열의 항목을 연결
};

// 2018-01-04T00:00:00 양식으로된 LocalDateTime객체를 -> 2018년 01월 04일 00시 00분 으로 변환
export const LocalDateTimeToText = isoDateString => {
  const date = new Date(isoDateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${year}년 ${month}월 ${day}일 ${hours}시 ${minutes}분`;
};

export const LocalDateToText = isoDateString => {
  const date = new Date(isoDateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1

  const day = String(date.getDate()).padStart(2, '0');

  return `${year}년 ${month}월 ${day}일`;
};

export const churchCityLetterCut = churchLabel => {
  if (isEmpty(churchLabel)) return '';
  return churchLabel.replace(/\s*\([^)]*\)/g, '').trim();
};

// xxxx년 xx월 xx일로 포맷
export const DateToDateText = originalDate => {
  const date = new Date(originalDate);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}년 ${month}월 ${day}일`;
};

export const formatNumber = value => {
  if (isEmpty(value)) return 0;
  return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

export const currentToDateTime = () => {
  const now = new Date();
  return now.toISOString();
};

// LocalDateTime xxxx-xx-xx 00:00 포맷
export const LocalDateTimeToString = LocalDateTime => {
  const date = new Date(LocalDateTime);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}`;
};

// 넣는 파라미터중 빈값이 있다면 delete 처리
export const REMOVE_EMPTY_PARAMS = obj => {
  return Object.fromEntries(Object.entries(obj).filter(([key, value]) => value !== ''));
};

export const ImageInfoBinding = (state, detail) => {
  for (let i = 0; i < detail.length; i++) {
    if (detail[i].order === 1) {
      if (detail[i].fileType === 'IMAGE') state.firstImageFileInfo = detail[i];
      else state.firstVideoFileInfo = detail[i];
    }
    if (detail[i].order === 2) {
      if (detail[i].fileType === 'IMAGE') state.secondImageFileInfo = detail[i];
      else state.secondVideoFileInfo = detail[i];
    }
  }
};
// 이미지 파일을 업로드할때 리스트객체에 담아서 해당 함수에서 필요한 객체명으로 분리처리.
// 해당 함수 사용시 넘겨주는 데이터는 cloneDeep해주는게 좋음. 잉여데이터를 넘기기싫어서 delete 처리하기때문에 view에 보이는 데이터가 지워질 수 있음
export const fileRequestBinding = (fileData, key = '') => {
  if (isEmpty(fileData.imageFile)) {
    delete fileData?.imageFile;
    delete fileData?.files;
    return;
  }
  if (isEmpty(key)) {
    if (fileData.imageFile.length >= 1 && !fileData.imageFile[0].hasOwnProperty('storedFileName')) {
      fileData.firstRawFile = fileData.imageFile[0];
    }
    if (fileData.imageFile.length >= 2 && !fileData.imageFile[1].hasOwnProperty('storedFileName')) {
      fileData.secondRawFile = fileData.imageFile[1];
    }
    if (fileData.imageFile.length >= 3 && !fileData.imageFile[2].hasOwnProperty('storedFileName')) {
      fileData.thirdRawFile = fileData.imageFile[2];
    }
    if (fileData.imageFile.length >= 4 && !fileData.imageFile[3].hasOwnProperty('storedFileName')) {
      fileData.fourthRawFile = fileData.imageFile[3];
    }
    if (fileData.imageFile.length >= 5 && !fileData.imageFile[4].hasOwnProperty('storedFileName')) {
      fileData.fifthRawFile = fileData.imageFile[4];
    }
  } else {
    if (fileData.imageFile[0].hasOwnProperty('storedFileName')) {
      fileData.fileInfo = fileData.imageFile[0];
    }
    if (!fileData.imageFile[0].hasOwnProperty('storedFileName')) {
      fileData[key] = fileData.imageFile[0];
      delete fileData.fileInfo;
    }
  }
  delete fileData?.imageFile;
  delete fileData?.files;
};

// 생년월일과 사망일자를 받아와 나이를 구함
export const calculateAge = (birthDate, deathDate) => {
  const birth = new Date(birthDate);
  const death = new Date(deathDate);
  // 사망 시 나이 계산
  let age = death.getFullYear() - birth.getFullYear();

  // 생일이 지나지 않았다면 1살을 빼줌
  const monthDiff = death.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && death.getDate() < birth.getDate())) {
    age--;
  }
  return age;
};

// 달력에 넣을 시간 계산 하는 함수
export const generateDateData = (startYear, endYear, isDateTime = false) => {
  const data = {};
  // 미리 계산된 10, 20, 30, 40, 50 분 배열 생성
  const minutes = [0, 10, 20, 30, 40, 50];
  if (!isDateTime) {
    for (let year = endYear; year >= startYear; year--) {
      data[year] = {};
      for (let month = 1; month <= 12; month++) {
        data[year][month] = [];
        for (let day = 1; day <= 31; day++) {
          data[year][month].push(day);
        }
      }
    }
  } else {
    for (let year = endYear; year >= startYear; year--) {
      data[year] = {};
      for (let month = 1; month <= 12; month++) {
        data[year][month] = {};
        for (let day = 1; day <= 31; day++) {
          data[year][month][day] = {};
          for (let hour = 0; hour < 24; hour++) {
            data[year][month][day][hour] = minutes; // 미리 계산된 분 배열을 참조
          }
        }
      }
    }
  }
  return data;
};

//  DeteTime으로 되어있는 데이터를 Date로 변환
export const convertDateTimeToDate = dateTimeStr => {
  // 입력 문자열에서 날짜와 시간 부분을 추출
  const [datePart] = dateTimeStr.split(' '); // 날짜 부분만 추출
  // 'YYYY-MM-DD' 형식의 문자열을 Date 객체로 변환
  const [year, month, day] = datePart.split('-').map(Number);
  // Date 객체 생성 (시간은 00:00:00로 설정됨)
  return new Date(year, month - 1, day);
};

/**
 * 'HH:mm' 형식을 'HH:mm:00' 형식으로 변환
 * @param dateTimeStr
 * @returns {string}
 */
export const convertHourMinuteToTime = dateTimeStr => {
  // 입력 문자열에서 날짜와 시간 부분을 추출
  const [hour, minute] = dateTimeStr.split(':'); // 시간 부분만 추출

  // 'HH:mm' 형식의 문자열을 'HH:mm:00' 형식으로 변환
  if (!hour || !minute) return '';
  if (isNaN(hour) || isNaN(minute)) return '';

  // Date 객체 생성 (시간은 00:00:00로 설정됨)
  return hour + ':' + minute;
};

// MEMO: 특정 DateTime 문자열을 DateTime 타입으로 변환
export const convertToLocalDateTime = dateTimeStr => {
  if (isEmpty(dateTimeStr)) return '';
  if (!dateTimeStr || typeof dateTimeStr !== 'string') return false;

  const [datePart, timePart] = dateTimeStr.split(' ');

  // 유효성 검사
  if (!datePart || !timePart) return false;

  const [year, month, day] = datePart.split('-').map(Number);
  const [hour, minute] = timePart.split(':').map(Number);

  if (isNaN(year) || isNaN(month) || isNaN(day) || isNaN(hour) || isNaN(minute)) return false;

  // Date 객체 생성
  const date = new Date(year, month - 1, day, hour, minute);

  // 날짜와 시간을 'yyyy-MM-dd'T'HH:mm:ss' 포맷으로 변환
  const localYear = date.getFullYear();
  const localMonth = String(date.getMonth() + 1).padStart(2, '0');
  const localDay = String(date.getDate()).padStart(2, '0');
  const localHour = String(date.getHours()).padStart(2, '0');
  const localMinute = String(date.getMinutes()).padStart(2, '0');
  const localSecond = String(date.getSeconds()).padStart(2, '0');
  // ISO 8601 포맷을 유지
  return `${localYear}-${localMonth}-${localDay}T${localHour}:${localMinute}:${localSecond}`;
};

// 가격에 ,를 뭍혀줌
export const toDot = (price = 0 | '') => {
  let num = '' + price;
  if (num.includes(',')) {
    num = unDot(num);
  }
  if (Number.isNaN(Number(num))) return '-';
  return num.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
export const unDot = (price = '') => {
  return price.replaceAll(',', '');
};

export const formatNumber2 = (value, options) => {
  if (this.isEmpty(value) || isNaN(value) || value === 0) return '-';
  let dl = options['decimalLength'] || 0;
  let ts = options['thousandsSep'] || ',';
  let ty = options['type'] || '';
  let ut = options['unit'] || '';

  if (ty !== '') value = value * 100;
  value = parseFloat(value);
  let re = '\\d(?=(\\d{3})+' + (dl > 0 ? '\\D' : '$') + ')';
  let num = value.toFixed(Math.max(0, ~~dl));
  return `${num.replace(new RegExp(re, 'g'), '$&' + ts)}${ut}`;
};
export const getPhoneFormat = (num, type = 1) => {
  let formatNum = '';
  try {
    if (num.length === 11) {
      if (type === 0) {
        formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-****-$3');
      } else {
        formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
      }
    } else if (num.length === 8) {
      formatNum = num.replace(/(\d{4})(\d{4})/, '$1-$2');
    } else {
      if (num.indexOf('02') === 0) {
        if (num.length === 10) {
          if (type === 0) {
            formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-****-$3');
          } else {
            formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
          }
        } else {
          if (type === 0) {
            formatNum = num.replace(/(\d{2})(\d{3})(\d{4})/, '$1-****-$3');
          } else {
            formatNum = num.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
          }
        }
      } else {
        if (num.length === 10) {
          if (type === 0) {
            formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-***-$3');
          } else {
            formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
          }
        } else {
          if (type === 0) {
            formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-***-$3');
          } else {
            formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
          }
        }
      }
    }
  } catch (e) {
    formatNum = num;
  }
  return formatNum;
};

export const formatLocalDate = value => {
  if (isEmpty(value)) return '';
  return dayjs(value).format('YYYY-MM-DD');
};

export const formatDate = (value, options = { flag: false }) => {
  let text = '';
  let flag = options['flag'] || false;
  if (value.length === 6) {
    text = flag
      ? `${value.substring(0, 4)}년 ${value.substring(4, 6)}월`
      : `${value.substring(0, 4)}-${value.substring(4, 6)}`;
  } else if (value.length === 8) {
    text = flag
      ? `${value.substring(0, 4)}년 ${value.substring(4, 6)}월 ${value.substring(6, 8)}일`
      : `${value.substring(0, 4)}-${value.substring(4, 6)}-${value.substring(6, 8)}`;
  } else if (value.length > 8) {
    text = value;
  } else {
    text = '-';
  }
  return text;
};
export const formatRpad = (target, value, n) => {
  return `${target}${Array(n - target.length + 1).join(value || '0')}`;
};
export const formatNumberToPhone = value => {
  if (isEmpty(value)) return '';
  return value.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, '$1-$2-$3');
};

export const formatMaskingPhone = phone => {
  if (!phone) return '';

  if (phone.length === 10) {
    // 010-123-****
    return phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-****');
  } else if (phone.length === 11) {
    // 010-1234-****
    return phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-****');
  } else {
    return phone;
  }
};

export const formatBizNum = value => {
  if (this.isEmpty(value)) return '';
  return value.replace(/([0-9]{3})([0-9]{2})([0-9]{5})/, '$1-$2-$3');
};
export const formatLpad = (target, value, n) => {
  if (this.isEmpty(target)) return '';
  target = target.toString();
  return `${Array(n - target.length + 1).join(value || '0')}${target}`;
};
export const formatStringBirth = (birth = '20010101') => {
  if (birth.length !== 8) return '';
  return `${birth.substr(0, 4)}.${birth.substr(4, 2)}.${birth.substr(6, 2)}`;
};

// LocalDateTime -> DateTime
// YYYY.MM.DD hh:mm
export const toLocalDate = date => {
  if (!date) return '-';
  if (date.includes('`T`')) return dayjs(date.replace('`T`', ' ')).format('YYYY.MM.DD');
  return dayjs(date).format('YYYY.MM.DD HH:mm');
};

// LocalDateTime -> Date
// YYYY.MM.DD
export const toLocalDate2 = date => {
  if (!date) return '-';
  if (date.includes('`T`')) return dayjs(date.replace('`T`', ' ')).format('YYYY.MM.DD');
  return dayjs(date).format('YYYY.MM.DD');
};
export const removeHyphen = phoneNumber => {
  if (isEmpty(phoneNumber)) return '';
  return phoneNumber.replace(/-/g, '');
};
export const toDateStr = date => {
  if (!date) return '-';
  return dayjs(date).format('YYYY.MM.DD');
};

export default {
  formatNumber,
  formatNumber2,
  getPhoneFormat,
  formatDate,
  formatRpad,
  formatNumberToPhone,
  formatBizNum,
  formatLpad,
  formatStringBirth
};
